import React, { useState, useEffect } from 'react';
import Card from '../components/common/Card';
import { ordersAPI } from '../api/orders';
import { paymentsAPI } from '../api/payments';
import { formatCurrency } from '../utils/formatters';
import { ORDER_STATUS } from '../utils/constants';

const Dashboard = () => {
  const [stats, setStats] = useState({
    todayOrders: 0,
    todayRevenue: 0,
    pendingOrders: 0,
    readyOrders: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      
      const [ordersResponse, paymentsResponse] = await Promise.all([
        ordersAPI.getAll({ startDate: today }),
        paymentsAPI.getDailySummary(today)
      ]);

      const orders = ordersResponse.data;
      const pendingOrders = orders.filter(o => o.status === ORDER_STATUS.PENDING).length;
      const readyOrders = orders.filter(o => o.status === ORDER_STATUS.READY).length;

      setStats({
        todayOrders: orders.length,
        todayRevenue: paymentsResponse.data.totalAmount || 0,
        pendingOrders,
        readyOrders
      });
    } catch (error) {
      console.error('Failed to load dashboard data', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="dashboard">
      <h1 className="page-title">Dashboard</h1>

      <div className="stats-grid">
        <Card className="stat-card stat-primary">
          <div className="stat-content">
            <h3>{stats.todayOrders}</h3>
            <p>Today's Orders</p>
          </div>
          <div className="stat-icon">📦</div>
        </Card>

        <Card className="stat-card stat-success">
          <div className="stat-content">
            <h3>{formatCurrency(stats.todayRevenue)}</h3>
            <p>Today's Revenue</p>
          </div>
          <div className="stat-icon">💰</div>
        </Card>

        <Card className="stat-card stat-warning">
          <div className="stat-content">
            <h3>{stats.pendingOrders}</h3>
            <p>Pending Orders</p>
          </div>
          <div className="stat-icon">⏳</div>
        </Card>

        <Card className="stat-card stat-info">
          <div className="stat-content">
            <h3>{stats.readyOrders}</h3>
            <p>Ready for Pickup</p>
          </div>
          <div className="stat-icon">✅</div>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;